export const SAVE_GUESTS = '/php/saveGuests.php';
export const GET_GUESTS = '/php/getGuests.php';
export const GET_TABLES = '/php/getTables.php';
export const GET_GROUPS = '/php/getGroups.php';
export const UPDATE_GUEST = '/php/updateGuest.php';
export const DELETE_GUEST = '/php/deleteGuest.php';
export const LOGIN = '/php/login.php';
export const CHANGE_GUEST_REGISTER = '/php/changeGuestRegister.php';